import { render, staticRenderFns } from "./PrivatePage.vue?vue&type=template&id=0b51f122&scoped=true&"
import script from "./PrivatePage.vue?vue&type=script&lang=js&"
export * from "./PrivatePage.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePage.vue?vue&type=style&index=0&id=0b51f122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b51f122",
  null
  
)

export default component.exports